import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Component from 'flarum/common/Component';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
export default class SignUpView extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "loading", true);
    _defineProperty(this, "SignUpSection", void 0);
  }
  oninit(vnode) {
    super.oninit(vnode);
    flarum.reg.asyncModuleImport('flarum/forum/components/SignUpModal').then(() => import(/* webpackChunkName: 'forum/components/SignUpSection', webpackMode: 'lazy-once' */ './SignUpSection').then(SignUpSection => {
      this.SignUpSection = SignUpSection.default;
      this.loading = false;
      m.redraw();
    }));
  }
  view() {
    if (this.loading) {
      return m(LoadingIndicator, null);
    }
    const SignUpSection = this.SignUpSection;
    return m(SignUpSection, {
      routeSwitcher: this.attrs.routeSwitcher,
      animateShow: () => null
    });
  }
}
flarum.reg.add('sycho-private-facade', 'forum/components/SignUpView', SignUpView);flarum.reg.addChunkModule('857', '169', 'sycho-private-facade', 'forum/components/SignUpSection');